import { connect } from 'react-redux';

import Preview from 'carbon-react/lib/components/preview';

const PreviewComponent = () => {
  return (
    <div className="homepage-container">
      <Preview height="50px" loading />
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          padding: '5%',
          paddingTop: '24px',
        }}
      >
        <div style={{ marginBottom: 24 }}>
          <Preview height="400px" loading />
        </div>
        <div style={{ marginBottom: 24 }}>
          <Preview height="400px" loading />
        </div>
        <div style={{ marginBottom: 24 }}>
          <Preview height="400px" loading />
        </div>
        <div style={{ marginBottom: 24 }}>
          <Preview height="400px" loading />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  dataSources: state.dataSources,
});

export default connect(mapStateToProps, null)(PreviewComponent);
